module.exports = __webpack_public_path__ + "img/thumb_33.2827f220.jpg";